export default __webpack_public_path__ + "static/media/rocket_anim_131.dedca8d6.png";